import { isNewBackend } from 'config';
import { UseAuthType } from '../types';
import useAuthPrem from '../useAuthOnPrem';
import useAuthSass from '../useAuthSass';

export default function useAuth(useSaasAuth = false): UseAuthType {
  const authPrem = useAuthPrem();
  const authSass = useAuthSass();
  return isNewBackend || useSaasAuth ? authSass : authPrem;
}
